import { STORAGE_TYPE } from './constants';
import { save, load } from './core';

export default {
  draft: {
    get value() {
      return load(STORAGE_TYPE.CHAT_DRAFT) || {};
    },
    get(id) {
      return this.value[id];
    },
    set(id, text) {
      const value = { ...this.value, ...{ [id]: text } };
      return save(STORAGE_TYPE.CHAT_DRAFT, value);
    },
    remove(id) {
      const value = { ...this.value };
      delete value[id];
      return save(STORAGE_TYPE.CHAT_DRAFT, value);
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/storage/chat.js